import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';
import Container from '../common/Container'; // ✅ PASSO 1: Importe o componente Container
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';

const TestimonialsWrapper = styled.section`
    padding: 120px 0;
    position: relative;
    background-color: ${({ theme }) => theme.colors.lighter};
`;

const TestimonialGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 40px;
`;

const TestimonialCard = styled.div`
    background: ${({ theme }) => theme.colors.lighter};
    border-radius: ${({ theme }) => theme.radii.lg};
    padding: 40px 32px;
    box-shadow: ${({ theme }) => theme.shadows.sm};
    transition: ${({ theme }) => theme.transitions.default};
    position: relative;
    overflow: hidden;

    &:hover {
        transform: translateY(-10px);
        box-shadow: ${({ theme }) => theme.shadows.lg};
    }

    /* Aspa gigante no fundo */
    &::before {
        content: '"';
        position: absolute;
        top: 20px;
        right: 30px;
        font-size: 100px;
        color: rgba(108, 92, 231, 0.05);
        font-family: serif;
        line-height: 1;
        z-index: 0;
    }
`;

const TestimonialText = styled.p`
    font-style: italic;
    margin-bottom: 28px;
    position: relative;
    z-index: 1;
    color: ${({ theme }) => theme.colors.dark};
    line-height: 1.7;
    font-size: 17px;
`;

const TestimonialAuthor = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const AuthorAvatar = styled.div`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.lighter};
    font-weight: 700;
    flex-shrink: 0;
    font-size: 20px;
`;

const AuthorInfo = styled.div`
    h4 {
        font-weight: 800;
        margin-bottom: 6px;
        color: ${({ theme }) => theme.colors.dark};
    }
    p {
        color: ${({ theme }) => theme.colors.gray};
        font-size: 15px;
    }
`;

const Rating = styled.div`
    color: ${({ theme }) => theme.colors.warning};
    margin-top: 6px;
    font-size: 15px;
`;

// Componente para renderizar as estrelas
const StarRating = ({ rating }) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (i <= rating) {
            stars.push(<FontAwesomeIcon icon={faStar} key={i} />);
        } else if (i === Math.ceil(rating) && !Number.isInteger(rating)) {
            stars.push(<FontAwesomeIcon icon={faStarHalfAlt} key={i} />);
        } else {
            // Pode adicionar estrela vazia se quiser
        }
    }
    return <Rating>{stars}</Rating>;
};


const TestimonialsSection = () => {
    const testimonials = [
        { name: "Pedro Fernandes", role: "Comprador em SP", avatar: "PF", text: "Economizei R$ 18.000 ao descobrir que o carro que ia comprar tinha sinistro total não declarado. O serviço se pagou 100 vezes!", rating: 5 },
        { name: "Ana Rocha", role: "Proprietária de loja", avatar: "AR", text: "Como lojista, uso o Consulta Veículos para todas as avaliações. A interface é perfeita e os relatórios são os mais completos do mercado.", rating: 5 },
        { name: "Luiza Mendes", role: "Primeira compra", avatar: "LM", text: "Fiz a consulta antes de fechar meu primeiro carro usado e descobri débitos escondidos. O vendedor nem sabia que existiam! Me salvou de uma furada.", rating: 4.5 }
    ];

    return (
        <TestimonialsWrapper id="depoimentos">
            {/* ✅ PASSO 2: Substituído a div pelo componente Container */}
            <Container>
                <SectionHeader 
                    title="Aprovado por quem entende"
                    subtitle="Veja o que nossos clientes estão falando sobre o Consulta Veículos."
                />
                <TestimonialGrid>
                    {testimonials.map(item => (
                        <TestimonialCard key={item.name}>
                            <TestimonialText>{item.text}</TestimonialText>
                            <TestimonialAuthor>
                                <AuthorAvatar>{item.avatar}</AuthorAvatar>
                                <AuthorInfo>
                                    <h4>{item.name}</h4>
                                    <p>{item.role}</p>
                                    <StarRating rating={item.rating} />
                                </AuthorInfo>
                            </TestimonialAuthor>
                        </TestimonialCard>
                    ))}
                </TestimonialGrid>
            </Container>
        </TestimonialsWrapper>
    );
};

export default TestimonialsSection;
